import 'svgxuse';
import 'lazysizes';
